import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cl-sort",
  "use": "icon-cl-sort-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-cl-sort\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"m3 7 4.046-4.634a1.425 1.425 0 0 1 1.908 0L13 7H3ZM13 9l-4.046 4.634a1.425 1.425 0 0 1-1.908 0L3 9h10Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol